module.exports = __webpack_public_path__ + "app/bento-components/blog-entry/media/default-image.svg?1b15dca348de74c952cd1ce3302a6d16";